/**
 * @classdesc Spanish Language Pack
 * @desc This class will used to translate tokens into the Spanish language.
 * @namespace Languages.Spanish
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Spanish
 */
export const dictionary = {
	'years'   : 'Años',
	'months'  : 'Meses',
	'days'    : 'Días',
	'hours'   : 'Horas',
	'minutes' : 'Minutos',
	'seconds' : 'Segundos'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Spanish
 */
export const aliases = ['es', 'es-es', 'spanish'];
